import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import NewsletterSignup from '../components/NewsletterSignup';
import usePageTitle from '../utils/usePageTitle';
import './Home.css';

const Home = () => {
  const { currentUser } = useContext(AuthContext);
  
  // For homepage, use just the app name without additional title parts
  usePageTitle('', false);
  return (
    <div className="home-container">
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to TradingCard.Life</h1>
          <p>Organize, track, trade, and share your trading card collection — free!</p>
          <div className="hero-buttons">
            {!currentUser ? (
              <Link to="/register" className="btn btn-primary">Create an Account</Link> 
            ) : (
              <Link to={`/@${currentUser.username}`} className="btn btn-primary">My Collection</Link>
            )}
            <Link to="/trading-card-sets" className="btn btn-secondary">Browse Trading Card Sets</Link>
          </div>
        </div>
      </section>

      <section className="features">
        <h2>Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Track Your Collection</h3>
            <p>Easily manage your card inventory, wishlist, and cards for trade..</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3>Find Missing Cards</h3>
            <p>Identify the cards you need to complete your sets with our comprehensive database.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔄</div>
            <h3>Trade with Others</h3>
            <p>Connect with other collectors, showcase your duplicates, and find cards for trade.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Access Anywhere</h3>
            <p>Use our platform on any device - from desktop to mobile, your collection is always with you.</p>
          </div>
        </div>
      </section>

      {!currentUser ? (
        <section className="call-to-action">
          <h2>Start Organizing Your Collection Today</h2>
          <p>Join like-minded collectors who trust TradingCard.Life to manage their collections.</p>
            <Link to="/register" className="btn btn-primary">Create Your Account</Link>
        </section>
      ) : <></>}
{/* 
      {!currentUser && (
        <section className="newsletter-section">
          <NewsletterSignup />
        </section>
      )} */}
    </div>
  );
};

export default Home;